import { atom } from 'jotai';

export interface ApiRetryErrorState {
  isOpen: boolean;
  title: string;
  description: string;
}

const initialState: ApiRetryErrorState = {
  isOpen: false,
  title: 'Something went wrong.',
  description: 'Please retry your content creation.',
};

export const apiRetryErrorAtom = atom<ApiRetryErrorState>(initialState);

apiRetryErrorAtom.debugLabel = 'apiRetryErrorAtom';
